import { setFlexDFFDC, styled } from "theme";

export const SComparisonSectionContent = styled.div`
  ${setFlexDFFDC};
`;
